import { selectPageViewObject } from '../../selectors/tracking';
import { TThunkAction } from '../../types/redux/thunk';
import { trackNewPage } from '../../utils/analytics';

/**
 * Redux thunk action, который отправляет событие открытия новой страницы
 */
export const trackNewPageAction = (): TThunkAction<void> => {
  return (dispatch, getState) => {
    const state = getState();
    const params = selectPageViewObject(state);

    trackNewPage(params);
  };
};
